module.exports = __webpack_public_path__ + "assets/img/robo2_16px.2e484318.svg";